import React from 'react';

import _ from 'lodash';

const DataColumn = ({
  children,
  style = null,
}): JSX.Element => {
  const defaultStyle = {
      marginBottom: '30px', // Mimic react-grid-system gutter
  };
  return (
    <div
      className="bg-white br-1 border-1-solid--transparent-brand pa-2"
      style={_.merge(defaultStyle, style)}
    >
      { children }
    </div>
  );
};

export default DataColumn;
